// Sidebar permission status messages
export const SIDEBAR_PERMISSION_STATUS = {
  FETCHING: "Fetching user permission...",
  ERROR: "Something went wrong please refresh the page",
};

// User details loader/error strings
export const USER_DETAILS_STRINGS = {
  FETCHING: "Fetching user details...",
  ERROR: "Something went wrong please refresh the page",
};
export const FILE_UPLOAD_PAYMENT_TYPE_OPTIONS = {
  SELECT: "Select Payment Type",
  BULK_TOPUP: "Bulk TopUp",
  BULK_BONUS: "Bulk Bonus",
};
export const FILE_UPLOAD_DIALOG_LABELS = {
  PAYMENT_TYPE: "Payment Type*",
  REMARK: "Remark*",
};
// ...existing code...

export const FILE_UPLOAD_DIALOG_TEXTS = {
  INVALID_FILE_TYPE: "Invalid file type. Please select an Excel file.",
  FILE_SIZE_EXCEEDS: "File size exceeds {max}MB.",
  CHOOSE_FILE: "Choose File",
  SELECTED_FILE: "Selected file",
  UPLOAD: "Upload",
};
export const NIGERIA_SMS_DASHBOARD_STRINGS = {
  FAILED_TO_LOAD_DATA: "Failed to load data.",
  ONLY_CSV_FILES_ALLOWED: "Only .csv files are allowed.",
  NO_DATA_TO_EXPORT: "No data to export.",
  EXPORT_FILE_NAME: "sms_dashboard_export.csv",
  FILE_UPLOADED_SUCCESS: "File uploaded successfully!",
  FAILED_TO_EXPORT: "Failed to export data.",
  STATUS: "Status",
  DATE: "Date",
  SUCCESS: "Success",
  FAILURE: "Failure",
  TOTAL: "Total",
  BULK_SMS_DASHBOARD_TITLE: "Bulk SMS Dashboard",
};
export const DASHBOARD_TOOLBAR_STRINGS = {
  SELECT_FIELD: "Select field",
  SELECT_FIELD_WARNING: "Please select a field before searching",
  DEFAULT_PLACEHOLDER: "Search here...",
  DOWNLOAD_SAMPLE: "Download Sample",
  SELECT_COLUMN_WARNING: "Select a Column",
  ENTER_SEARCH_QUERY_WARNING: "Enter search query",
  SEARCH: "Search",
  EXPORT: "Export",
  UPLOAD: "Upload",
  CONFIRM_FILE_UPLOAD: "Confirm File Upload",
  CONFIRM_UPLOAD_QUESTION: "Are you sure you want to upload",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
};
// Redux Action Types for Customer Recharge Slice
export const CUSTOMER_RECHARGE_ACTIONS = {
  FETCH_CASH_RECHARGE_DETAILS:
    "fetchCashRechargeDetails/fetchCashRechargeDetails",
  CALCULATE_RECHARGE_AMOUNT: "customerRecharge/calculateRechargeAmount",
  CALCULATE_RECHARGE_AMOUNT_TOOLKIT:
    "calculateRechargeAmount/calculateRechargeAmount",
  CREATE_CASH_PAYMENT: "createCashPayment/createCashPayment",
  FETCH_CUSTOMER_LIST: "fetchCustomerList/fetchCustomerList",
  FETCH_PLANTS: "fetchPlants/fetchPlants",
  APPLY_COUPON_CODE: "applyCouponCode/applyCouponCode",
};
// Payment/Confirmation static strings
export const PAYMENT_SECTION_STRINGS = {
  CONFIRM_PAYMENT: "Are you sure you want to proceed with payment?",
};
// Discount/Recharge UI static strings
export const DISCOUNT_SECTION_STRINGS = {
  PLAN_CHANGE_DISCOUNT_HELPER:
    "Discount coupon is not applicable for Plan Change.",
  COUPON_SUCCESS_MESSAGE: "Discount applied successfully",
};
// Toast warning messages
export const TOAST_WARNING_MESSAGES = {
  SELECT_AT_LEAST_ONE_METER: "Please select at least one meter",
  NO_DATA_TO_EXPORT: "No data to export.",
};

// Toast error messages
export const TOAST_ERROR_MESSAGES = {
  ERROR_CONFIRMING_ACTION: "Error confirming action",
  ERROR_SAVING_MESSAGE: "Error saving message",
  ERROR_CREATING_CHAT: "Error creating chat",
  ERROR_FETCHING_CHATS: "Error fetching chats",
  ERROR_FETCHING_MESSAGES: "Error fetching messages",
  API_ERROR: "API error",
  SERVER_TIMEOUT: "Server timeout. Please try again.",
  INCORRECT_EMAIL_OR_PASSWORD: "Incorrect email or password",
  RESOURCE_NOT_FOUND: "Resource Not Found",
  GENERIC_ERROR: "An error occurred",
};

export const COMMON_TEXT = {
  ALERT: "Alert",
  THIS_FIELD_IS_REQUIRED: "This field is required",
  LOADING: "Loading...",
  FILTERS: "Filters",
  ERROR_FETCHING_MESSAGES: "Error fetching messages",
  API_ERROR: "API error",
  SERVER_TIMEOUT: "Server timeout. Please try again.",
  INCORRECT_EMAIL_OR_PASSWORD: "Incorrect email or password",
  FILE_UPLOAD: "File Upload",
};

// Placeholder texts
export const PLACEHOLDER_TEXTS = {
  USERNAME: "Enter your username",
  PASSWORD: "Enter your password",
  OTP: "Enter OTP",
  SEARCH: "Search...",
  METER_SERIAL: "Enter Meter Serial",
  CUSTOMER_NAME: "Enter customer name",
  EMAIL: "Enter email address",
  SEARCH_CHAT: "Search Chat",
  ASK_HMG: "Ask me about HMG",
  ENTER_TAGS: "Tags",
  ENTER_METER_LAST_ENERGY: "Enter Meter Last Energy",
  SELECT_DATE: "Select date",
  SEARCH_HERE: "Search here...",
  // Recharge related placeholders
  CUSTOMER_NAME_CRN_PHONE: "Customer Name/CRN/Phone Number",
  ENTER_NAME_CRN_PHONE: "Enter Name / CRN / Phone Number",
  ENTER_COUPON_CODE: "Enter coupon code here",
  SELECT_PLANT: "Select Plant",
  ENTER_TOP_UP_AMOUNT: "Enter Top Up Amount",
  REFUND_REASON: "Refund Reason",
};

// Helper texts
export const HELPER_TEXTS = {
  ENTER_NAME_CRN_PHONE_INFO: "ℹ️ Enter Name / CRN / Phone Number",
};

// Label texts
export const LABEL_TEXTS = {
  CANCEL: "Cancel",
  SAVE: "Save",
  DISSOCIATE: "Dissociate",
  ADD: "Add",
  SELECT_PLANT_DETAILS: "Select Plant Details",
  SELECT_POLE_NUMBER: "Select Pole Number",
  SELECT_PLANT_SERVER_TYPE: "Select Plant Server Type",
  SELECT_METER_SERIAL: "Select Meter Serial",
  CLOSE_QR_SCANNER: "Close QR Scanner",
  SCAN_QR_CODE: "Scan QR Code",
  COUNTRY: "Country",
  STATE: "State",
  NOC: "NOC",
  PLANT: "Plant *",
  POLE: "Pole",
  ASSIGN: "ASSIGN",
  MANUFACTURER: "Manufacturer",
  METER_SERIAL: "Meter Serial",
  TAGS: "Tags",
  METER_LAST_ENERGY: "Meter Last Energy",
  SPARK_METER_EDIT_METER_TITLE: "SparkMeterV2 – Edit Meter",
  OPERATING_MODE: "Operating Mode :",
  POWER_TYPE: "Power Type :",
  METER_STATE: "Meter State :",
  WAREHOUSE: "Warehouse",
  IS_ACTIVE: "Is Active",
  SPARKMETER_V1_LIST: "SparkMeter-V1 - List",
  SPARKMETER_V2_LIST: "SparkMeter-V2 - List",
  METERS_WIP_LIST: "Meters (WIP) - List",
  YES: "Yes",
  // Recharge related labels
  SELECT_PLAN_NAME: "Select New Tariff Plan",
  PLANT_NAME: "Plant Name :",
  CUSTOMER: "Customer :",
  CRN: "CRN :",
  CREDIT_BALANCE: "Credit Balance :",
  PLAN_BALANCE: "Plan Balance :",
  TARIFF_PLAN: "Tariff Plan :",
  RECHARGE_STATUS: "Recharge Status :",
  RECHARGE_TYPE: "Recharge Type :",
  RECHARGE_AMOUNT: "Top Up Amount :",
  MONTHLY_AMOUNT: "Recharge Amount :",
  DISCOUNT_COUPON_CODE: "Discount Coupon Code :",
  DISCOUNT_AMOUNT: "Discount Amount :",
  PAY_AMOUNT: "Pay Amount :",
  CUSTOMER_RECHARGE: "Customer Recharge",
  RECHARGED_LIST: "Recharged - List",
  PENDING_RECHARGE_LIST: "Pending Recharge - List",
  NOT_RECHARGED_LIVE_CUSTOMERS: "Not Recharged Live Customers",
  TRANSACTION: "Transactions",
  REFUND: "Refund Transactions",
  VIEW_TRANSACTIONS: "Transactions - View",
  VIEW_REFUND_TRANSACTIONS: "Refund Payment - View",
  REFUND_REASON: "Refund Reason:",
  REFUND_AMOUNT: "Refund Amount:",
  PAYMENT_REFUND: "Payment Refund",
  IS_REFUND_APPLICABLE: "IsRefundApplicable"
};

// Button names
export const BUTTON_NAMES = {
  LOGIN: "Login",
  SUBMIT: "Submit",
  CANCEL: "Cancel",
  SEND_OTP: "Send OTP",
  VERIFY_OTP: "Verify OTP",
  SEARCH: "Search",
  SAVE: "Save",
  EDIT: "Edit",
  DELETE: "Delete",
  CLOSE: "Close",
  ACTIVATE: "Active",
  ARCHIVE: "Archive",
  EXPORT: "Export",
  ADD_METER: "+ Add",
  // Recharge related buttons
  APPLY: "Apply",
  PAY: "Pay",
  PROCESSING: "Processing",
  REFUND: "Refund",
  GO_BACK: "Go Back",
};
// General status strings
export const STATUS = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  ACTIVE: "active",
  ARCHIVE: "archive",
};

// General error messages
export const ERROR_MESSAGES = {
  API_ERROR: "API error",
  ERROR_SAVING_MESSAGE: "Error saving message",
  ERROR_CREATING_CHAT: "Error creating chat",
  ERROR_FETCHING_CHATS: "Error fetching chats",
  ERROR_FETCHING_MESSAGES: "Error fetching messages",
  ERROR_CONFIRMING_ACTION: "Error confirming action",
  NO_DATA_TO_EXPORT: "No data to export.",
};

// Customer Recharge Specific
export const CUSTOMER_RECHARGE_STRINGS = {
  MISSING_PAYMENT_INFO: "Missing required information for payment",
  CONFIRM_PAYMENT: "Are you sure you want to process this payment?",
  PAYMENT_SUCCESS: "Payment processed successfully!",
  PAYMENT_FAILED: "Payment failed. Please try again.",
  SELECT_CUSTOMER: "Please select a customer",
  SELECT_RECHARGE_TYPE: "Please select a recharge type",
  SELECT_PLAN_AMOUNT: "Please select a valid plan amount",
  WAIT_FOR_CALCULATION: "Please wait for amount calculation to complete",
  ENTER_DISCOUNT_CODE: "Please enter a discount code",
  RESET_TAB_KEY: "shouldResetTab",
  RECHARGE_LABEL: "Recharge",
  MONTHLY_RECHARGE: "Monthly Recharge",
  MONTHLY_RECHARGE_NO_SPACE: "MonthlyRecharge",
  TOP_UP: "TopUp",
  TOP_UP_SPACED: "Top Up",
  PLAN_CHANGE: "PlanChange",
  PLAN_CHANGE_SPACED: "Plan Change",
  // Added for CustomerRechargeViewModel error messages
  CANNOT_PROCEED_MISSING_CALC_OR_PAYAMOUNT:
    "Cannot proceed: calculationResult is missing or invalid, and no valid PayAmount from API.",
  CANNOT_PROCEED_FINAL_PAYAMOUNT_ZERO:
    "Cannot proceed: finalPayAmount is zero or not set.",
  CANNOT_PROCEED_PAY_BUTTON_DISABLED:
    "Cannot proceed: Pay button is disabled by API (IsPayButtonEnabled=false).",
  CANNOT_PROCEED_PLAN_AMOUNT_ZERO:
    "Cannot proceed: selectedPlanAmount is zero or not set.",
  MISSING_TOPUP_PLAN: "Cannot proceed: missing TopUp plan.",
  MISSING_TARIFF_PLAN: "Cannot proceed: missing Tariff plan.",
  // Context provider error
  CONTEXT_PROVIDER_ERROR:
    "useCustomerRecharge must be used within a CustomerRechargeProvider",
  // Error boundary message
  TAB_ERROR_BOUNDARY_MESSAGE: "Something went wrong loading this tab.",
};

// General info messages
export const INFO_MESSAGES = {
  HI_ASK_HMG: "Hi! Ask me about your HMG.",
  COULD_NOT_FETCH_MESSAGES: "Could not fetch messages.",
  OTP_SENT_SUCCESS: "OTP sent to registered mobile number",
  MOBILE_NOT_AVAILABLE: "mobile Number Not Available",
  OTP_SENDING_FAILED: "OTP sending failed",
  INCORRECT_EMAIL_OR_PASSWORD: "Incorrect email or password",
  UNKNOWN_RESPONSE: "Unknown response from AuthenticateAndSendOTP",
  // Recharge related info messages
  DISCOUNT_APPLIED_SUCCESSFULLY: "Discount Applied successfully",
  REFUND_REASON: "Please enter the reason for refund",
  REFUND_AMOUNT: "Please enter the refund amount",
};

// Validation messages (example from meter serial validation)
export const VALIDATION_MESSAGES = {
  ENTER_METER_SERIAL: "Please enter meter serial",
  THREE_PARTS: 'Meter serial should be in three parts with " - " separation',
  STARTS_WITH_SM: "Meter serial should starts with SM in first part",
};
export type ActionType = "activate" | "archive";

export const CONFIRMATION_MESSAGES: Record<ActionType, string> & {
  defaultWithSerial: (actionVerb: string, meterSerial: string) => string;
} = {
  activate: "Are you sure you want to activate the selected meters?",
  archive: "Are you sure you want to archive the selected meters?",
  defaultWithSerial: (actionVerb, meterSerial) =>
    `Are you sure you want to ${actionVerb} this meter ${meterSerial}?`,
};

export const EDIT_METER_MESSAGES = {
  REASON: "Other",
  COMMENT: "no comment",
};

export const TOAST_MESSAGES = {
  METER_CREATED_SUCCESS: "Meter Created successfully",
  METER_EDITED_SUCCESS: "Meter Edited successfully",
  METER_DISSOCIATED_SUCCESS: "Meter dissociated successfully",
  PAYMENT_SUCCESS: "Payment processed successfully!",
  RECHARGE_DETAILS_LOADED: "Recharge details loaded successfully",
};

export const SERVICE_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  DEFAULT_IS_ACTIVE: "All",
  CHECK_PERMISSION: "CHECK_MULTIPLE",
};
// Authentication Related Strings
export const AUTH_STRINGS = {
  // Page Titles
  LOGIN_TITLE: "Please Login To Continue",
  ENTER_OTP_TITLE: "Enter OTP",

  // Labels
  USERNAME_LABEL: "User Name",
  PASSWORD_LABEL: "Password",

  // Placeholders
  EMAIL_PLACEHOLDER: "Enter your email",
  PASSWORD_PLACEHOLDER: "Enter your password",

  // Messages
  OTP_SENT_MESSAGE: "We have sent an OTP to your mobile number",
  LOGIN_SUCCESS_MESSAGE: "Login successful!",
  OTP_SENT_SUCCESS: "OTP sent successfully!",

  // Button Text
  LOGIN_BUTTON: "Login",
  VERIFY_OTP_BUTTON: "Verify OTP",
  RESEND_OTP_BUTTON: "Resend OTP",
  SHOW_PASSWORD: "Show Password",
  HIDE_PASSWORD: "Hide Password",

  // Error Messages
  INVALID_OTP_ERROR: "Invalid OTP",
  PHONE_MISSING_ERROR: "Phone number missing",
  EMAIL_REQUIRED_ERROR: "Please enter your email address",
  PASSWORD_REQUIRED_ERROR: "Please enter your password",
  LOGIN_FAILED_ERROR: "Login failed",
  OTP_VERIFICATION_FAILED_ERROR: "OTP verification failed",
  RESEND_OTP_FAILED_ERROR: "Failed to resend OTP",
  USER_NOT_FOUND_ERROR: "User not found",
  INVALID_PASSWORD_ERROR: "Invalid password",
  INVALID_CREDENTIALS_ERROR: "Invalid email or password",
  OTP_REQUIRED_ERROR: "Please enter OTP",

  // Success Messages
  LOGIN_SUCCESS: "Login successful",
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",

  // Timer Messages
  RESEND_OTP_TIMER: (seconds: number) => `Resend OTP in ${seconds}s`,

  // Permissions
  NO_EDIT_PERMISSION: "You do not have permission to edit this meter.",

  // Alt Text
  LOGO_ALT_TEXT: "Husk Power Logo",
};

export const MANUAL_CASH_PAYMENTS_IMPORT_CONSTANTS = {
  PAGE_TITLE: "Manual Cash Payments Import",
  DOWNLOAD_SAMPLE: "Download Sample",
  UPLOAD: "Upload",
  UPLOAD_MESSAGE: "Please upload the Excel file.",
  IMPORT_TITLE: "Import Excel File",
  MAX_FILE_SIZE_MB: 5,
};

export const MANUAL_CASH_PAYMENTS_CARD_LIST_CONSTANTS = {
  DOWNLOAD_FILE_TOOLTIP: "Download File",
  FILE_NAME_LABEL: "File Name:",
  CREATED_ON_LABEL: "Created On:",
  TOTAL_LABEL: "Total:",
  SUCCESS_LABEL: "Success:",
  FAILURE_LABEL: "Failure:",
};

// Transaction Page Constants
export const TRANSACTION_STRINGS = {
  // Column Headers
  PLANT_NAME: "Plant Name",
  ORDER_ID: "Order Id",
  CRN: "CRN",
  CUSTOMER_NAME: "Customer Name",
  METER_SERIAL: "Meter Serial",
  REVENUE: "Revenue",
  PAYMENT_TYPE: "Payment Type",
  CUSTOMER_TAG: "Customer Tag",
  BILLING_DATE: "Billing Date",
  TRANSACTION_DATE: "Transaction Date",
  VIEW: "View",

  // Toolbar Labels
  SELECT_FIELD: "Select field",
  SELECT_FIELD_WARNING: "Please select a field before searching",
  SEARCH_PLACEHOLDER: "Search here....",

  // Filter Labels
  FILTERS: "Filters",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  SOURCE: "Source",
  STATUS: "Status",
  FILTER: "Filter",

  // Summary Card Labels
  DIRECT_REVENUE: "Direct Revenue",
  AGENT_REVENUE: "Agent Revenue",
  TOTAL_REVENUE: "Total Revenue",
  MR_DIRECT_AGENT: "MR Direct / Agent",
  TOPUP_DIRECT_AGENT: "Topup Direct / Agent",
  TOTAL_MR: "Total MR",
  TOTAL_TOPUPS: "Total Topups",

  // Currency
  CURRENCY_PREFIX: "₹ ",

  // Card Labels
  CUSTOMER_NAME_LABEL: "Customer Name:",
  ORDER_ID_LABEL: "Order ID:",
  CRN_LABEL: "CRN:",
  METER_SERIAL_LABEL: "Meter Serial:",
  PAYMENT_TYPE_LABEL: "Payment Type:",
  CUSTOMER_TYPE_LABEL: "Customer Type:",
  CUSTOMER_TAG_LABEL: "Customer Tag:",
  BILLING_DATE_LABEL: "Billing Date:",
  TRANSACTION_DATE_LABEL: "Transaction Date:",

  // Dropdown Options
  ALL: "All",
  DIRECT: "Direct",
  AGENT: "Agent",
  COMPLETED: "Completed",
  PENDING: "Pending",
  WEB: "Web",
  EZPAY: "EzPay",
  RETAIL: "Retail",
  HPS_POS: "HPS-POS",

  // Test IDs
  TRANSACTION_TOOLBAR_TEST_ID: "transaction-toolbar",

  // Context Errors
  CONTEXT_PROVIDER_ERROR:
    "useTransaction must be used within a TransactionProvider",

  // Empty State
  NO_RECORD_FOUND: "No Record Found",
};

// Request Types for API calls
export const REQUEST_TYPES = {
  TRANSACTIONS: "Transactions",
  REFUND_TRANSACTIONS: "RefundTransactions",
} as const;

// Billing/Date Types for filtering
export const BILLING_TYPES = {
  BILLING_DATE: "BillingDate",
  TRANSACTION_DATE: "TransactionDate",
} as const;

// Transaction Search Field Options
export const TRANSACTION_SEARCH_FIELDS = {
  CRN: "CRN",
  ORDER_ID: "Order Id",
  CUSTOMER_NAME: "Customer Name",
  METER_SERIAL: "Meter Serial",
  PLANT_NAME: "Plant Name",
};

// Refund Transaction Page Constants
export const REFUND_TRANSACTION_STRINGS = {
  // Column Headers
  PLANT_NAME: "Plant Name",
  METER_SERIAL: "Meter Serial",
  ORDER_ID: "Order Id",
  CUSTOMER_NAME: "Customer Name",
  PAYMENT_TYPE: "Payment Type",
  REFUNDED_AMOUNT: "Refunded Amount",
  REFUND_STATUS: "Refund Status",
  REFUNDED_DATE: "Refunded Date",
  VIEW: "View",

  // Toolbar Labels
  SEARCH_PLACEHOLDER: "Search here....",
  FROM_DATE: "From Date",
  END_DATE: "End Date",
  FILTER: "Filter",

  // Currency
  CURRENCY_PREFIX: "₹",

  // Card Labels
  CUSTOMER_NAME_LABEL: "Customer Name:",
  ORDER_ID_LABEL: "Order ID:",
  METER_SERIAL_LABEL: "Meter Serial:",
  PAYMENT_TYPE_LABEL: "Payment Type:",
  REFUND_STATUS_LABEL: "Refund Status:",
  REFUNDED_DATE_LABEL: "Refunded Date:",
  REFUNDED_AMOUNT_LABEL: "Refunded Amount:",

  // Dropdown Options
  ALL: "All",
  DIRECT: "Direct",
  AGENT: "Agent",
  SELECT_FIELD: "Select Field",
  PLEASE_SELECT_SEARCH_FIELD: "Please select a search field",

  // Context Errors
  CONTEXT_PROVIDER_ERROR:
    "useRefundTransaction must be used within a RefundTransactionProvider",

  // Empty State
  NO_RECORD_FOUND: "No Record Found",
};
